// Shared helpers for server-side (lazy) table sorting.
//
// PrimeReact's DataTable reports sort direction as 1 (ascending) / -1
// (descending); the API expects the pair `sort_by` + `sort_dir=asc|desc`, e.g.
//   /api/v1/customers-search?page=1&perPage=10&sort_by=full_name&sort_dir=asc
// Every list service funnels through here so the contract stays identical
// across modules.

export const SORT_BY_PARAM = "sort_by";
export const SORT_DIR_PARAM = "sort_dir";

/** 1 | -1 | null -> "asc" | "desc" (defaults to ascending). */
export const sortDirFromOrder = (sortOrder) =>
  Number(sortOrder) === -1 ? "desc" : "asc";

/** Appends sort params to a URLSearchParams instance. No-op without a field. */
export const appendSortParams = (params, sortBy, sortOrder) => {
  if (sortBy) {
    params.append(SORT_BY_PARAM, sortBy);
    params.append(SORT_DIR_PARAM, sortDirFromOrder(sortOrder));
  }
  return params;
};

/** Merges sort params into a plain object (for apiCall's `params` argument). */
export const withSortParams = (params = {}, sortBy, sortOrder) =>
  sortBy
    ? {
        ...params,
        [SORT_BY_PARAM]: sortBy,
        [SORT_DIR_PARAM]: sortDirFromOrder(sortOrder),
      }
    : { ...params };

/**
 * Query-string fragment for services that build URLs by concatenation.
 * Returns "" (not "&") when no sort is active so callers can append blindly.
 */
export const sortQueryString = (sortBy, sortOrder) =>
  sortBy
    ? `&${SORT_BY_PARAM}=${encodeURIComponent(sortBy)}&${SORT_DIR_PARAM}=${sortDirFromOrder(
        sortOrder,
      )}`
    : "";
